import { createAsyncThunk } from "@reduxjs/toolkit";
import managementService from "../services/management.service";

export const fetchQuotaFiscalQuartersFilters = createAsyncThunk(
  "skygeni-management/quota-filters",
  async () => {
    const response = await managementService.getQuotaFiscalQuarterFilters();
    return response;
  }
);

export const fetchQuotaData = createAsyncThunk(
  "skygeni-management/quota-data",
  async ({ filters, isDryRun }) => {
    const response = await managementService.getQuotaDataV2(filters, isDryRun);
    return response;
  }
);
export const fetchTeamQuotaData = createAsyncThunk(
  "skygeni-management/quota-data/team",
  async ({ filters, isDryRun }) => {
    const response = await managementService.getTeamQuotaDataV2(
      filters,
      isDryRun
    );
    return response;
  }
);
export const fetchCompanyQuotaData = createAsyncThunk(
  "skygeni-management/quota-data/company",
  async ({ filters, isDryRun }) => {
    const response = await managementService.getCompanyQuotaDataV2(
      filters,
      isDryRun
    );
    return response;
  }
);
export const updateQuotaData = createAsyncThunk(
  "quota-maintainence/quota/update",
  async ({ updatedObjects, isDryRun }) => {
    const response = await managementService.updateQuotaDataV2(
      updatedObjects,
      isDryRun
    );
    return response;
  }
);
export const getTeamAndFiscalQuarters = createAsyncThunk(
  "quota-management/quota-removal/initiate",
  async ({ type } = {}) => {
    const response = await managementService.initiateQuotaRemoval(type);
    return response;
  }
);
export const updateTeamQuotaData = createAsyncThunk(
  "quota-maintainence/quota/team/update",
  async ({ updatedObjects, isDryRun }) => {
    const response = await managementService.updateTeamQuotaData(
      updatedObjects,
      isDryRun
    );
    return response;
  }
);
export const updateCompanyQuotaData = createAsyncThunk(
  "quota-maintainence/quota/company/update",
  async ({ updatedObjects, isDryRun }) => {
    const response = await managementService.updateCompanyQuotaData(
      updatedObjects,
      isDryRun
    );
    return response;
  }
);

export const removeQuotaForReps = createAsyncThunk(
  "quota-management/quota-removal/quota-reps",
  async ({ team, fiscalQuarter }) => {
    const response = await managementService.removeQuotaForReps({ team, fiscalQuarter });
    return response;
  }
);
export const removeQuotaForRepsQuarterInfo = createAsyncThunk(
  "quota-management/quota-removal/quota-reps-modal",
  async ({ team, userId, fiscalQuarter }) => {
    const response = await managementService.removeQuotaForReps({ team, userId, fiscalQuarter });
    return response;
  }
);

export const deleteQuotaRemoval = createAsyncThunk(
  "quota-management/quota-removal/delete",
  async ({ team, fiscalQuarters, userId }) => {
    const response = await managementService.deleteQuotaRemoval({ team, fiscalQuarters, userId });
    return response;
  }
);

export const getQuotaAddingReps = createAsyncThunk(
  "quota-management/quota-adding/reps",
  async () => {
    const response = await managementService.getQuotaAddingReps();
    return response;
  }
);

export const getQuotaAddingRepInfo = createAsyncThunk(
  "quota-management/quota-adding/rep-info",
  async ({ userId }) => {
    const response = await managementService.getQuotaAddingRepInfo({ userId });
    return response;
  }
);

export const createQuotaInfo = createAsyncThunk(
  "quota-management/quota-adding/create",
  async ({ createQuotaBody }) => {
    const response = await managementService.createQuotaInfo(createQuotaBody);
    return response;
  }
);

export const createQuotaInfoOverride = createAsyncThunk(
  "quota-management/quota-adding/create-override",
  async ({ createQuotaBody }) => {
    const response = await managementService.createQuotaInfo(createQuotaBody);
    return response;
  }
);

export const bulkUpsertQuotaData = createAsyncThunk(
  "quota-management/quota-bulk-upsert",
  async ({ bulkQuotaData }) => {
    const response = await managementService.bulkUpsertQuota(bulkQuotaData);
    return response;
  }
);

export const bulkUpsertTeamQuotaData = createAsyncThunk(
  "quota-management/team-quota-bulk-upsert",
  async ({ bulkTeamQuotaData }) => {
    const response = await managementService.bulkUpsertTeamQuota(bulkTeamQuotaData);
    return response;
  }
);

export const bulkUpsertCompanyQuotaData = createAsyncThunk(
  "quota-management/company-quota-bulk-upsert",
  async ({ bulkCompanyQuotaData }) => {
    const response = await managementService.bulkUpsertCompanyQuota(bulkCompanyQuotaData);
    return response;
  }
);

export const getQuotaAddingQuarters = createAsyncThunk(
  "quota-management/quota-adding/quarters",
  async ({ type } = {}) => {
    const response = await managementService.getQuotaAddingQuarters(type);
    return response;
  }
);
export const getQuotaTeamsThunk = createAsyncThunk(
  "quota-management/quota-removal/quota-teams",
  async ({ team, fiscalQuarter }) => {
    const response = await managementService.getQuotaTeams({ team, fiscalQuarter });
    return response;
  }
);

export const deleteQuotaTeamThunk = createAsyncThunk(
  "quota-management/quota-removal/quota-teams/delete",
  async ({ team, fiscalQuarters }) => {
    const response = await managementService.deleteQuotaTeam({ team, fiscalQuarters });
    return response;
  }
);

export const getQuotaTeamsDrilldownThunk = createAsyncThunk(
  "quota-management/quota-removal/quota-teams/drilldown",
  async ({ team, fiscalQuarter }) => {
    const response = await managementService.getQuotaTeams({ team, fiscalQuarter });
    return response;
  }
);

export const getQuotaCompanyThunk = createAsyncThunk(
  "quota-management/quota-removal/quota-company",
  async ({ fiscalQuarter }) => {
    const response = await managementService.getQuotaCompany({ fiscalQuarter });
    return response;
  }
);

export const deleteQuotaCompanyThunk = createAsyncThunk(
  "quota-management/quota-removal/quota-company/delete",
  async ({ fiscalQuarter }) => {
    const response = await managementService.deleteQuotaCompany({ fiscalQuarter });
    return response;
  }
);

export const getCurrentAndFutureTeamQuotasThunk = createAsyncThunk(
  "quota-management/quota-adding/teams",
  async () => {
    const response = await managementService.getCurrentAndFutureTeamQuotas();
    return response;
  }
);

export const getCurrentAndFutureCompanyQuotasThunk = createAsyncThunk(
  "quota-management/quota-adding/company",
  async () => {
    const response = await managementService.getCurrentAndFutureCompanyQuotas();
    return response;
  }
);

export const createTeamQuotaThunk = createAsyncThunk(
  "quota-management/quota-adding/create-team",
  async ({ createTeamQuotaBody }) => {
    const response = await managementService.createTeamQuota(createTeamQuotaBody);
    return response;
  }
);

export const createTeamQuotaOverrideThunk = createAsyncThunk(
  "quota-management/quota-adding/create-override-team",
  async ({ createTeamQuotaBody }) => {
    const response = await managementService.createTeamQuota(createTeamQuotaBody);
    return response;
  }
);

export const createCompanyQuotaThunk = createAsyncThunk(
  "quota-management/quota-adding/create-company",
  async ({ createCompanyQuotaBody }) => {
    const response = await managementService.createCompanyQuota(createCompanyQuotaBody);
    return response;
  }
);

export const createCompanyQuotaOverrideThunk = createAsyncThunk(
  "quota-management/quota-adding/create-override-company",
  async ({ createCompanyQuotaBody }) => {
    const response = await managementService.createCompanyQuota(createCompanyQuotaBody);
    return response;
  }
);

export const getAvailableFiscalQuarters = createAsyncThunk(
  "quota-management/quota-update/available-fiscal-quarters",
  async ({ type }) => {
    const response = await managementService.getAvailableFiscalQuarters(type);
    return response;
  }
);

/**
 * Update quota with optimistic locking
 * Checks old value matches current DB value before updating
 * Returns successful and failed updates separately
 */
export const updateQuotaWithOptimisticLock = createAsyncThunk(
  "quota-maintainence/quota/updateWithLock",
  async ({ updatedObjects, isDryRun }, { rejectWithValue }) => {
    try {
      const response = await managementService.updateQuotaWithOptimisticLock(
        updatedObjects,
        isDryRun
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Update team quota with optimistic locking
 */
export const updateTeamQuotaWithOptimisticLock = createAsyncThunk(
  "quota-maintainence/team/updateWithLock",
  async ({ updatedObjects, isDryRun }, { rejectWithValue }) => {
    try {
      const response = await managementService.updateTeamQuotaWithOptimisticLock(
        updatedObjects,
        isDryRun
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * Update company quota with optimistic locking
 */
export const updateCompanyQuotaWithOptimisticLock = createAsyncThunk(
  "quota-maintainence/company/updateWithLock",
  async ({ updatedObjects, isDryRun }, { rejectWithValue }) => {
    try {
      const response = await managementService.updateCompanyQuotaWithOptimisticLock(
        updatedObjects,
        isDryRun
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
